import React, { Component } from "react";
import { Icon, Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";
import AdminMenuLateral from "./AdminMenuLateral";
import { getUserNode } from "../../../services/auth_node";
import AlunosSelector from "../../../components/Admin/AlunosSelector";

import "./styles.css";


const handleAlunoChange = (value) => {
    
  if(value){
    window.location.href =`/admin/dashboard/aluno/${value}`;

  }
};

export default class AdminMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  inscricao() {
    return (window.location.href =
      "https://www.voitto.com.br/admin/inscricoes");
  }

  render() {
    return (
      <div style={{width: "100%"}}>
        <AdminMenuLateral
          onMouseLeave={() => this.setState({ visible: false })}
          visible={this.state.visible}
        />

          <Menu
            className="main-menu-node"
            style={{
              display: "flex",
              justifyContent: "space-between",
              minHeight: "50px",
              width: "100%",
            }}
          >
            {/* <div style={{ display: "flex"}}>
              <Menu.Item
                onClick={() => this.setState({ visible: true })}
                className="force-black"
              >
                <Icon name="bars" />
              </Menu.Item>
              <Menu.Item
                className="force-black"
                onClick={() => this.inscricao()}
              >
                Inscrições
              </Menu.Item>
            </div> */}
            <div style={{ display: "flex", width:"100%", margin:"0 1rem"}}>
              <AlunosSelector handleChange={handleAlunoChange} isDash/>
            </div>
            <div style={{ display: "flex" }}>
              <Menu.Item as={'a'} href="/meu-aprendizado?tipo=profile">
              <div
                style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}
              >
                <img
                  width="40px"
                  height="40px"
                  style={{ borderRadius: "20px" }}
                  src={getUserNode().foto}
                />
              </div>
              </Menu.Item>
            </div>
          </Menu>
      </div>
    );
  }
}
